import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
export function usePediatricCheckEffect({ usageDetails, dispatch, setPediatricDraftValue, setPediatricCheck }) {
    useEffectWithErrorLogging(() => {
        if (usageDetails?.procedureCode) {
            dispatch(setPediatricCheck(usageDetails?.pediatricSurgery));
            if (
                usageDetails?.pediatricSurgery !== '' &&
                usageDetails?.pediatricSurgery !== undefined
            ) {
                setPediatricDraftValue(true);
            }
        }
    }, [usageDetails?.pediatricSurgery]);
}
